import { render } from "./DiscountCodes.vue?vue&type=template&id=1bf5443e"
import script from "./DiscountCodes.vue?vue&type=script&lang=js"
export * from "./DiscountCodes.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__